let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dAIxO")).then(() => parcelRequire('3usA2'));